module.exports = __webpack_public_path__ + "static/media/code-icon-active.b839fff0.svg";